define('gamebox/math', ['exports', 'module', './clamp', './lerp', './inverselerp'], function (exports, module, _clamp, _lerp, _inverselerp) {
  'use strict';

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _clamp2 = _interopRequire(_clamp);

  var _lerp2 = _interopRequire(_lerp);

  var _inverseLerp = _interopRequire(_inverselerp);

  'use strict';

  module.exports = { clamp: _clamp2, lerp: _lerp2, inverseLerp: _inverseLerp };
});